module.exports = __webpack_public_path__ + "img/229.e4b1fa90.jpg";